import * as ambassadorWixIdentityV1Contributor from './identity-v1-contributor-contributors.http.js';
import * as ambassadorWixIdentityV1ContributorTypes from './identity-v1-contributor-contributors.types.js';
import * as ambassadorWixIdentityV1ContributorUniversalTypes from './identity-v1-contributor-contributors.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getSiteContributorsV2(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixIdentityV1ContributorUniversalTypes.GetSiteContributorsV2Request,
  ambassadorWixIdentityV1ContributorTypes.GetSiteContributorsV2Request,
  ambassadorWixIdentityV1ContributorUniversalTypes.GetSiteContributorsV2Response,
  ambassadorWixIdentityV1ContributorTypes.GetSiteContributorsV2Response
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIdentityV1Contributor.getSiteContributorsV2(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/contributors',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCurrentContributor(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixIdentityV1ContributorUniversalTypes.GetCurrentContributorRequest,
  ambassadorWixIdentityV1ContributorTypes.GetCurrentContributorRequest,
  ambassadorWixIdentityV1ContributorUniversalTypes.GetCurrentContributorResponse,
  ambassadorWixIdentityV1ContributorTypes.GetCurrentContributorResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIdentityV1Contributor.getCurrentContributor(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/contributors/current',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function changeRole(): __PublicMethodMetaInfo<
  'PUT',
  {},
  ambassadorWixIdentityV1ContributorUniversalTypes.ChangeContributorRoleRequest,
  ambassadorWixIdentityV1ContributorTypes.ChangeContributorRoleRequest,
  ambassadorWixIdentityV1ContributorUniversalTypes.ChangeContributorRoleResponse,
  ambassadorWixIdentityV1ContributorTypes.ChangeContributorRoleResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIdentityV1Contributor.changeRole(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/contributor/change/role',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function changeContributorLocation(): __PublicMethodMetaInfo<
  'PUT',
  {},
  ambassadorWixIdentityV1ContributorUniversalTypes.ChangeContributorLocationRequest,
  ambassadorWixIdentityV1ContributorTypes.ChangeContributorLocationRequest,
  ambassadorWixIdentityV1ContributorUniversalTypes.ChangeContributorLocationResponse,
  ambassadorWixIdentityV1ContributorTypes.ChangeContributorLocationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIdentityV1Contributor.changeContributorLocation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/contributor/change/locations',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function querySiteContributors(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixIdentityV1ContributorUniversalTypes.QuerySiteContributorsRequest,
  ambassadorWixIdentityV1ContributorTypes.QuerySiteContributorsRequest,
  ambassadorWixIdentityV1ContributorUniversalTypes.QuerySiteContributorsResponse,
  ambassadorWixIdentityV1ContributorTypes.QuerySiteContributorsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIdentityV1Contributor.querySiteContributors(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/contributors/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getContributorsQuota(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixIdentityV1ContributorUniversalTypes.GetContributorsQuotaRequest,
  ambassadorWixIdentityV1ContributorTypes.GetContributorsQuotaRequest,
  ambassadorWixIdentityV1ContributorUniversalTypes.GetContributorsQuotaResponse,
  ambassadorWixIdentityV1ContributorTypes.GetContributorsQuotaResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIdentityV1Contributor.getContributorsQuota(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/contributors/quota',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeContributor(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixIdentityV1ContributorUniversalTypes.RemoveContributorRequest,
  ambassadorWixIdentityV1ContributorTypes.RemoveContributorRequest,
  ambassadorWixIdentityV1ContributorUniversalTypes.RemoveContributorResponse,
  ambassadorWixIdentityV1ContributorTypes.RemoveContributorResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIdentityV1Contributor.removeContributor(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/contributor/remove',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Contributor as ContributorOriginal,
  PersonMetaData as PersonMetaDataOriginal,
  Assignment as AssignmentOriginal,
  AssignedPolicy as AssignedPolicyOriginal,
  Restriction as RestrictionOriginal,
  RestrictionRestrictionsOneOf as RestrictionRestrictionsOneOfOriginal,
  Resource as ResourceOriginal,
  ResourceType as ResourceTypeOriginal,
  ResourceTypeWithLiterals as ResourceTypeWithLiteralsOriginal,
  Conditions as ConditionsOriginal,
  Condition as ConditionOriginal,
  ConditionAttributeType as ConditionAttributeTypeOriginal,
  ConditionAttributeTypeWithLiterals as ConditionAttributeTypeWithLiteralsOriginal,
  SiteRestriction as SiteRestrictionOriginal,
  CompanionResource as CompanionResourceOriginal,
  LocationsRestriction as LocationsRestrictionOriginal,
  Subject as SubjectOriginal,
  SubjectType as SubjectTypeOriginal,
  SubjectTypeWithLiterals as SubjectTypeWithLiteralsOriginal,
  SubjectContext as SubjectContextOriginal,
  SubjectContextType as SubjectContextTypeOriginal,
  SubjectContextTypeWithLiterals as SubjectContextTypeWithLiteralsOriginal,
  GetAppContributorsRequest as GetAppContributorsRequestOriginal,
  GetAppContributorsResponse as GetAppContributorsResponseOriginal,
  AppInvite as AppInviteOriginal,
  GetSiteContributorsRequest as GetSiteContributorsRequestOriginal,
  GetSiteContributorsResponse as GetSiteContributorsResponseOriginal,
  User as UserOriginal,
  Name as NameOriginal,
  Team as TeamOriginal,
  ApiAccountInfo as ApiAccountInfoOriginal,
  SiteInvite as SiteInviteOriginal,
  InviteStatus as InviteStatusOriginal,
  InviteStatusWithLiterals as InviteStatusWithLiteralsOriginal,
  Policy as PolicyOriginal,
  PendingOwner as PendingOwnerOriginal,
  ContributorLimit as ContributorLimitOriginal,
  PredefinedRoles as PredefinedRolesOriginal,
  PredefinedRole as PredefinedRoleOriginal,
  Role as RoleOriginal,
  GetSiteContributorsV2Request as GetSiteContributorsV2RequestOriginal,
  GetSiteContributorsV2Response as GetSiteContributorsV2ResponseOriginal,
  ContributorsQuota as ContributorsQuotaOriginal,
  ContributorsQuotaOptionsOneOf as ContributorsQuotaOptionsOneOfOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  LimitedOptions as LimitedOptionsOriginal,
  EnrichedSiteInvite as EnrichedSiteInviteOriginal,
  LocalizedPolicyInfo as LocalizedPolicyInfoOriginal,
  GetCurrentContributorRequest as GetCurrentContributorRequestOriginal,
  GetCurrentContributorResponse as GetCurrentContributorResponseOriginal,
  HandleSiteTransferRequest as HandleSiteTransferRequestOriginal,
  HandleSiteTransferResponse as HandleSiteTransferResponseOriginal,
  GetCurrentUserRolesRequest as GetCurrentUserRolesRequestOriginal,
  GetCurrentUserRolesResponse as GetCurrentUserRolesResponseOriginal,
  LocalizedRole as LocalizedRoleOriginal,
  BulkGetUserRolesOnSiteRequest as BulkGetUserRolesOnSiteRequestOriginal,
  UserSubject as UserSubjectOriginal,
  BulkGetUserRolesOnSiteResponse as BulkGetUserRolesOnSiteResponseOriginal,
  UserLocalizedRoles as UserLocalizedRolesOriginal,
  BulkValidateEmailInviteEligibilityRequest as BulkValidateEmailInviteEligibilityRequestOriginal,
  BulkValidateEmailInviteEligibilityResponse as BulkValidateEmailInviteEligibilityResponseOriginal,
  EmailInviteEligibility as EmailInviteEligibilityOriginal,
  ChangeContributorRoleRequest as ChangeContributorRoleRequestOriginal,
  SiteRoleAssignment as SiteRoleAssignmentOriginal,
  ChangeContributorRoleResponse as ChangeContributorRoleResponseOriginal,
  ChangeContributorLocationRequest as ChangeContributorLocationRequestOriginal,
  ChangeContributorLocationResponse as ChangeContributorLocationResponseOriginal,
  SiteLocationAssignment as SiteLocationAssignmentOriginal,
  QuerySiteContributorsRequest as QuerySiteContributorsRequestOriginal,
  QuerySiteContributorsFilter as QuerySiteContributorsFilterOriginal,
  FieldSet as FieldSetOriginal,
  FieldSetWithLiterals as FieldSetWithLiteralsOriginal,
  QuerySiteContributorsResponse as QuerySiteContributorsResponseOriginal,
  ContributorV2 as ContributorV2Original,
  GetContributorsQuotaRequest as GetContributorsQuotaRequestOriginal,
  GetContributorsQuotaResponse as GetContributorsQuotaResponseOriginal,
  RemoveContributorRequest as RemoveContributorRequestOriginal,
  RemoveContributorResponse as RemoveContributorResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './identity-v1-contributor-contributors.types.js';
